import React, {useState, useEffect, useCallback} from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import {useNavigate} from "react-router";
import project from "./Project";


const ProjectCard = ({value,id}) => {
    const {
        name,
        pushed_at,
        image,
    } = value;
    const navigate = useNavigate();


    const handleClick = () => {
        console.log(id)
        // if (id === 'project-0') {
        //     window.open(`/portfolio/project/${value.id}`, "_blank"); // 第一个项目点击时在新标签页打开
        // }
        window.open(`/portfolio/project/${value.id}`, "_blank"); // 第一个项目点击时在新标签页打开
    };

    return (
        <Col md={12} sm={12} sx={12}>
            <div
                className="project-card"
                style={{
                    position: "relative",
                    overflow: "hidden",
                    height: "480px" , // 设置卡片高度

                    borderRadius: "0", // Optional: No rounded corners
                }}
            >{/* Overlay Text */}
                <div
                    className="card-image"
                    style={{

                        backgroundImage: `url(${value.image})`,
                        backgroundRepeat: "no-repeat",
                        backgroundClip: "border-box", // 确保图片在边框内
                        overflow: "hidden",          // 防止溢出
                        height: "100%", // 设置卡片高度
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        width: "100%",
                        transition: "all 0.3s ease-in-out",
                        filter: "blur(0px)",
                    }}
                ></div>
                <div
                    className="card-overlay"
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "rgba(255,255,255,0.35)", // Semi-transparent black overlay
                        color: "black",
                        fontSize: "3rem",
                        fontWeight: "bold",
                        opacity: 0,
                        transition: "all 0.3s ease-in-out",
                        // cursor: id === 'project-0' ? "pointer" : "not-allowed", // 只有 id 为 0 时才允许点击
                        cursor:"pointer"
                    }}
                    // onClick={() => navigate(`/project/${value.id}`)}
                    onClick={handleClick} // 只有第一个项目会触发 handleClick
                    >
                    {name}
                </div>
                <Card className="no-border-card  p-3  bg-white "
                      style={{

                          borderRadius: "0",           // 去掉圆角
                          // color: "white",  // 确保文字颜色与图片对比清晰
                      }}
                >
                    {/*<Card.Body >*/}
                    {/*  <Card.Title as="h5">{name || <Skeleton />} </Card.Title>*/}
                    {/*  <Card.Text>{(!description) ? "" : description || <Skeleton count={3} />} </Card.Text>*/}
                    {/*  {svn_url ? <CardButtons svn_url={svn_url} /> : <Skeleton count={2} />}*/}
                    {/*  /!*<hr />*!/*/}
                    {/*  {languages_url ? (*/}
                    {/*    <Language languages_url={languages_url} repo_url={svn_url} />*/}
                    {/*  ) : (*/}
                    {/*    <Skeleton count={3} />*/}
                    {/*  )}*/}
                    {/*  /!*{value ? (*!/*/}
                    {/*  /!*  <CardFooter star_count={stargazers_count} repo_url={svn_url} pushed_at={pushed_at} />*!/*/}
                    {/*  /!*) : (*!/*/}
                    {/*  /!*  <Skeleton />*!/*/}
                    {/*  /!*)}*!/*/}
                    {/*</Card.Body>*/}
                </Card>
            </div>
        </Col>
    );
};

const CardButtons = ({svn_url}) => {
    return (
        <div className="d-grid gap-2 d-md-block">
            <a
                href={`${svn_url}/archive/master.zip`}
                className="btn btn-outline-secondary mx-2"
            >
                <i className="fab fa-github"/> Clone Project
            </a>
            <a href={svn_url} target=" _blank" className="btn btn-outline-secondary mx-2">
                <i className="fab fa-github"/> Repo
            </a>
        </div>
    );
};

const Language = ({languages_url, repo_url}) => {
    const [data, setData] = useState([]);

    const handleRequest = useCallback(async () => {
        try {
            const response = await axios.get(languages_url);
            return setData(response.data);
        } catch (error) {
            console.error(error.message);
        }
    }, [languages_url]);

    useEffect(() => {
        handleRequest();
    }, [handleRequest]);

    const array = [];
    let total_count = 0;
    for (let index in data) {
        array.push(index);
        total_count += data[index];
    }

    return (
        <div className="pb-3">
            Languages:{" "}
            {array.length
                ? array.map((language) => (
                    <a
                        key={language}
                        className="card-link"
                        href={repo_url + `/search?l=${language}`}
                        target=" _blank"
                        rel="noopener noreferrer"
                    >
            <span className="badge bg-light text-dark">
              {language}:{" "}
                {Math.trunc((data[language] / total_count) * 1000) / 10} %
            </span>
                    </a>

                ))
                : "code yet to be deployed."}
        </div>
    );
};

const CardFooter = ({star_count, repo_url, pushed_at}) => {
    const [updated_at, setUpdated_at] = useState("0 mints");

    const handleUpdatetime = useCallback(() => {
        const date = new Date(pushed_at);
        const nowdate = new Date();
        const diff = nowdate.getTime() - date.getTime();
        const hours = Math.trunc(diff / 1000 / 60 / 60);

        if (hours < 24) {
            if (hours < 1) return setUpdated_at("just now");
            let measurement = hours === 1 ? "hour" : "hours";
            return setUpdated_at(`${hours.toString()} ${measurement} ago`);
        } else {
            const options = {day: "numeric", month: "long", year: "numeric"};
            const time = new Intl.DateTimeFormat("en-US", options).format(date);
            return setUpdated_at(`on ${time}`);
        }
    }, [pushed_at]);

    useEffect(() => {
        handleUpdatetime();
    }, [handleUpdatetime]);

    return (
        <p className="card-text">
            <a
                href={repo_url + "/stargazers"}
                target=" _blank"
                className="text-dark text-decoration-none"
            >
        <span className="text-dark card-link mr-4">
          <i className="fab fa-github"/> Stars{" "}
            <span className="badge badge-dark">{star_count}</span>
        </span>
            </a>
            <small className="text-muted">Updated {updated_at}</small>
        </p>
    );
};

export default ProjectCard;
